import { createFileRoute } from '@tanstack/react-router';

import { DocumentUploadPage } from '@/views/public/candidature/DocumentUploadPage';

export const Route = createFileRoute('/_public/candidature/documents/$token')({
  component: DocumentUploadPage,
});
